// groupTravel.js

const groupTravel = {
  id: 5,
  title: "Group Travel",
  questions: [
    {
      question: "Do you organize group tours?",
      answer:
        "Yes, we organize family trips, student tours, corporate outings, and large group travel experiences.",
    },
    {
      question: "Are group discounts available?",
      answer:
        "Yes, special pricing and discounts are available depending on the group size and destination.",
    },
    {
      question: "Can meals and activities be included?",
      answer:
        "Yes, meals, activities, guides, and transportation can all be included in the package.",
    },
  ],
};

export default groupTravel;